import styled from 'styled-components';

export const PolicyContainer = styled.div`
  padding: 16px 20px;
  & h2 {
    font-size: 24px;
    font-weight: 500;
    color: rgb(0 0 0 / 87%);
    padding-bottom: 10px;
    min-height: 34px;
    padding-top: 10px;
  }
  & h3 {
    font-size: 20px;
    font-weight: 500;
    color: rgb(0 0 0 / 87%);
    padding-bottom: 10px;
    min-height: 34px;
  }

  .term {
    font-size: 18px;
    min-height: 32.4px;
  }

  & p {
    font-size: clamp(14px, 2vw, 16px);
    color: #000000de;
    padding: 0 0 14px;
    text-align: justify;
  }

  .useOfMylo {
    min-height: 98px;

    @media (max-width: 720px) {
      min-height: 300px;
    }
  }

  .purpose {
    min-height: 131px;

    @media (max-width: 720px) {
      min-height: 380px;
    }
  }

  .blupinInfo {
    min-height: 98px;

    @media (max-width: 720px) {
      min-height: 300px;
    }
  }

  .this_document {
    @media (max-width: 720px) {
      min-height: 81.2px;
    }
  }

  & a {
    color: inherit;
  }

  & .anchor {
    display: block;
    position: relative;
    visibility: hidden;
    top: -98px;
  }
  .mail {
    text-decoration: underline;
    font-weight: 500;
    cursor: pointer;
    @media (max-width: 720px) {
      cursor: default;
    }
  }
`;
export const ContactUsContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  p {
    font-size: 14px;
    font-weight: 500;
    color: blue;
    text-decoration: underline;
  }
  @media (max-width: 720px) {
    cursor: default;
  }
  .margin {
    margin-left: 10px;
  }
`;
